import styled, { css } from 'styled-components';

const br = '16px';
export const Bubble = styled.div`
  padding: 1rem;
  white-space: pre-line; /* ensure line breaks are implemented */
  line-height: 1.3rem;
  position: relative;
  margin-top: 0.2rem;
  word-break: break-word;
  ${(props) =>
    props.chatType === 'bot' &&
    css`
      border-radius: 0 ${br} ${br} ${br};
      background-color: var(--chat-item-bot-bg-color);
      color: var(--chat-item-bot-text-color);
      /* we want to give bot responses enough width to show score key hit  */
      min-width: 14.3rem;
    `}
  ${(props) =>
    props.chatType === 'user' &&
    css`
      background-color: var(--chat-item-user-bg-color);
      color: var(--chat-item-user-text-color);
      border-radius: ${br} 0 ${br} ${br};
    `}
    ${(props) =>
    props.chatType === 'user' &&
    props.feedbackText !== '' &&
    css`
      width: 100%;
    `}
    min-width: initial;
`;
